<template>
    <ui-nav class="content-nav">
        <ui-nav-item :active="active == 'overview'" :action="() => $emit('goTo', 'overview')" class="small text-uppercase">
            Overview
        </ui-nav-item>
        <ui-nav-item :active="active == 'photos'" :action="() => $emit('goTo', 'photos')" class="small text-uppercase">
            Gallery
        </ui-nav-item>
        <ui-nav-item :active="active == 'amenities'" :action="() => $emit('goTo', 'amenities')" class="small text-uppercase">
            Amenities
        </ui-nav-item>
        <ui-nav-item v-if="showAvailability" :active="active == 'availability'" :action="() => $emit('goTo', 'availability')" class="small text-uppercase">
            Availability
        </ui-nav-item>
        <ui-nav-item v-if="showHotelRooms" :active="active == 'hotelRooms'" :action="() => $emit('goTo', 'hotelRooms')" class="small text-uppercase">
            {{ hotelShortLabel }}
        </ui-nav-item>
        <ui-nav-item v-if="showReviews" :active="active == 'reviews'" :action="() => $emit('goTo', 'reviews')" class="small text-uppercase">
            Reviews
        </ui-nav-item>
        <ui-nav-item :active="active == 'rooms'" :action="() => $emit('goTo', 'rooms')" class="small text-uppercase">
            Rooms
        </ui-nav-item>
        <ui-nav-item :active="active == 'location'" :action="() => $emit('goTo', 'location')" class="small text-uppercase">
            Location
        </ui-nav-item>
        <ui-nav-item :active="active == 'facts'" :action="() => $emit('goTo', 'facts')" class="small text-uppercase">
            Facts
        </ui-nav-item>
    </ui-nav>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';

    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            ...CommonComponents,
        },

        props: {
            active: {
                type: String,
                default: 'overview',
            },

            showAvailability: {
                type: Boolean,
                default: true,
            },

            showReviews: {
                type: Boolean,
                default: true,
            },
            
            property: {
                type: ApiObject,
                required: true,
            },
        },

        emits: ['goTo'],

        computed: {
            showHotelRooms() {
                if (
                    (this.property.isHotel) && 
                    (this.property.canBookHotelRooms) &&
                    (this.property.liveHotelRooms) &&
                    (this.property.liveHotelRooms.length)
                ) {
                    return true;
                }

                return false;
            },

            hotelShortLabel() {

                if (
                    (this.property) &&
                    (this.property.hotelSettings) &&
                    (this.property.hotelSettings.hotelTypeShortLabel)
                ) {
                    return this.property.hotelSettings.hotelTypeShortLabel;
                }

                return 'Hotel';
            },
        },
    };

</script>
